import axios from 'axios'

var url="http://192.168.31.47:8090";
const instance=axios.create({
    baseURL:url
})
export default instance